<template>
  <div class="success">
    <div
      class="all"
      @mouseover="send"
      @mouseleave="remove"
    >
      <div
        class="item mb-2 cursor-pointer"
        @click="nextPage"
      >
        {{ name }}
      </div>
      <div class="w-1/3 ">
        <divider
          :color="color"
          :height="height"
          class="diviseur"
        />
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/helper/divider'

export default {
  name: 'Success',
  components: {
    divider
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      color: '#0D1734',
      height: '4px'
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    remove () {
      this.color = '#0D1734'
    },
    send () {
      this.color = 'linear-gradient(90deg, #7E23EF 1.33%, #2651ED 98.31%)'
      this.$emit('hover', this.path)
    },
    nextPage () {
      this.$emit('close', false)
      this.$router.push('/' + this.path)
    }
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../../assets/style/sass/mixin";

    .item{
      font-style: normal;
      font-weight: 800;
      font-size: 48px;
      line-height: 170%;
      color: $white;
    }
    .diviseur{
      display: block;
    }

    @media screen and (max-width: 600px){
      .item{
        font-weight: 800;
        font-size: 32px;
        line-height: 170%;
        color: $white;
      }
    }
    @media screen and (min-width: 701px) and (max-width: 1024px){
      .item{
        font-size: 40px;
      }
    }
</style>
